import * as types from '../mutation-types';
import {unionState} from '../helpers';

const state = () => ({
	tags: [],
});

const actions = {
	fetchAll({commit}) {
		return axios.get('/api/tags').then(response => {
			commit(types.STORE_TAGS, response.data);
		});
	},

	fetch({commit}, {id}) {
		return axios.get(`/api/tags/${id}`).then(response => {
			commit(types.STORE_TAG, response.data);

			return response.data;
		});
	},

	create({commit}, {name}) {
		return axios.post('/api/tags', {name}).then(response => {
			commit(types.STORE_TAG, response.data);

			return response.data;
		});
	},

	delete({commit}, {id}) {
		return axios.delete(`/api/tags/${id}`).then(() => {
			commit(types.DELETE_TAG, id);
		});
	},

	update({commit}, {id, name}) {
		return axios.put(`/api/tags/${id}`, {name}).then(response => {
			commit(types.STORE_TAG, response.data);

			return response.data;
		});
	}
};

const mutations = {
	[types.STORE_TAGS](state, tags) {
		state.tags = unionState(state.tags, tags);
	},

	[types.STORE_TAG](state, tag) {
		state.tags = unionState(state.tags, [tag]);
	},

	[types.DELETE_TAG](state, id) {
		state.tags = state.tags.filter(t => t.id !== id);
	}
};

const getters = {
	getById: state => id => state.tags.find(t => t.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};